module.exports = __webpack_public_path__ + "arrow-red.png?11ccf6492cdaf0b6535be04f28f6085c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-red.png
// module id = 8
// module chunks = 0